import { CLEAR_NETWORK_BROWSE_GROUPS } from 'actions';

export default function clearNetworkBrowseGroups() {
  return {
    type: CLEAR_NETWORK_BROWSE_GROUPS,
  };
}
